const bazarEn = {
  common: {
    brandLabel: 'Brand',
    storeLabel: 'Store',
    unitCount: '',
  },
  search: {
    placeholders: [
      'Type a product name...',
      'Type a brand name...',
      'Type a store name...',
      'Type a category name...'
    ]
  },
  sidebar: {
    categoriesTitle: 'Categories',
    storesTitle: 'Stores',
  },
  store: {
    serviceAreaLabel: 'Service Area',
    nationwide: 'Nationwide',
    productCount: 'Products',
    productsOfSuffix: 'Products',
    description: 'Below are all available products from this store. You can filter by category.',
  },
  buttons: {
    details: 'Details',
    addToCart: 'Add to Cart',
    clearFilters: 'Clear Filters',
    close: 'Close',
  },
  empty: {
    title: 'No products found',
    subtitle: 'Please adjust your filters or search',
  },
};

export default bazarEn;



